import { Message, Notification } from 'element-ui';
export const ShowSuccessMessage = (message, showClose = false) => {
  Message({
    showClose,
    message,
    type: 'success',
    duration: showClose ? 0 : 2500,
  });
};
export const ShowWarningMessage = (message, duration = 2500) => {
  Message({
    showClose: false,
    message,
    type: 'warning',
    duration,
  });
};
export const ShowErrorMessage = (message) => {
  Message({
    showClose: false,
    message,
    type: 'error',
    duration: 2500,
  });
};
export const showTimeMessage = (message, leftTime = 6000, title = 'Log in', callback) => {
  let time = leftTime;
  const m = Message({
    showClose: false,
    message: `<div style="display:flex;justify-content:space-between;width:370px;">
                <span>${message}</span>
                <span><span style="font-weight:bold;margin-right:19px;">${title}</span>
                <span></span>${time / 1000}s</span>
              </div>`,
    type: 'info',
    duration: time,
    dangerouslyUseHTMLString: true,
    onClose: () => {
      if (callback) {
        callback();
      }
    },
  });
  const timer = setInterval(() => {
    time -= 1000;
    m.message = `<div style="display:flex;justify-content:space-between;width:370px;">
                  <span>${message}</span>
                  <span><span style="font-weight:bold;margin-right:19px;">${title}</span>
                  <span></span>${time / 1000}s</span>
                </div>`;
    if (time <= 0) {
      clearInterval(timer);
    }
  }, 1000);
};
export const showNotifyMessage = (title, message) => {
  Notification({
    title,
    message,
    position: 'bottom-right',
    duration: 0,
  });
};
